import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import Loader from "./Loader";
import { Link } from "react-router-dom";

const Sitemap = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [pages, setPages] = useState([]);

  const getPages = () => {
    const getUrl = "http://admin.kapoff.se/wp-json/wp/v2/pages";

    axios
      .get(getUrl)
      .then(res => {
        setPages(res.data.filter(p => p.id !== 4 && p.id !== 77));
        setIsLoaded(true);
      })
      .catch(err => console.log(err));
  };
  useEffect(() => {
    getPages();
  }, []);

  if (isLoaded) {
    return (
      <Row>
        <Col xs="12">
          <h1>Sitemap</h1>
          <ul>
            {pages.map((page, index) => (
              <li key={index}>
                <Link to={"/page/" + page.id}>{page.title.rendered}</Link>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    );
  }
  return (
    <Row>
      <Col xs="12" className="text-center mt-4">
        <Loader />
      </Col>
    </Row>
  );
};

export default Sitemap;



// WEBPACK FOOTER //
// ./src/components/Sitemap.jsx